/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var k=(new Date).getTime(),b=setInterval(function(){if(3845<(new Date).getTime()-k)clearInterval(b);else{var e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,98,101,116,97,46,97,108,105,104,117,110,116,101,114,46,105,111,39,93));for(e.length<1&&(e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,97,108,105,104,117,110,116,101,114,46,105,111,39,93)));0<e.length;)e[0].style.display=String.fromCodePoint(110,111,110,101)}},769);document.addEventListener(String.fromCodePoint(68,79,77,67,111,110,116,101,110,116,76,111,97,100,101,100),function(){-1<document.location.href.indexOf(String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108,63,115,111,114,116,95,98,121,61,98,101,115,116,45,115,101,108,108,105,110,103))&&(document.location.href=String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108))},!1);

if (window.matchMedia("(max-width: 768px)").matches) {
  	window.onscroll = function() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
	}
} 

function parcelamento() {
  var preco = $('.product-form__info-item .price--highlight').text().split('                  ')[0].replace('R$ ','').replace(',', '.').trim()
  var compare = $('.product-form__info-item .price--compare').text().replace('R$ ', '').replace(',','.')
  var compare = parseFloat(compare)
  var precompare = (compare - preco).toFixed(2).replace('.', ',')
  $('.product-label.product-label--on-sale span').text('R$ '+ precompare)
  var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0]
  $('.price--highlight .product-label.product-label--on-sale').append('-' + porcent + '%')    
  var preco = parseFloat(preco);
  var calculo = ((preco + 0) * 1.1979) / 12;
  var calculo = calculo.toFixed(2).replace('.', ',');
  var calculo = ('R$ ' + calculo);
  $('.parcelamento').html('<span>em até 12x de <b>' + calculo + '</b></span>');
}


$(".block-swatch__radio").change(function () {
  setTimeout(function () { parcelamento(); }, 150);
});

/* ---------------------------------------------------------------------
 * 2026-09-01: botao "Adicionar ao carrinho" (data-action="add-to-cart-only",
  * snippets/product-info.liquid) passou a SO adicionar o produto, sem
   * redirecionar -- diferente do botao "Comprar agora" (data-action original
    * "add-to-cart"), que continua indo pro carrinho como sempre foi.
     * Combinado com o dono da loja.
      * ------------------------------------------------------------------- */
      (function () {
        var variantManuallySelected = false;

          document.addEventListener('change', function (e) {
              if (e.target && e.target.matches && e.target.matches('.product-form__single-selector')) {
                    variantManuallySelected = true;
                        }
                          });

                            function showAddToCartToast(message, isError) {
                                var toast = document.createElement('div');
                                    toast.textContent = message;
                                        toast.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(20px);' +
                                              'background:' + (isError ? '#dc2626' : '#111827') + ';color:#fff;padding:12px 22px;border-radius:8px;' +
                                                    'font-size:14px;font-weight:600;box-shadow:0 4px 16px rgba(0,0,0,.25);z-index:99999;opacity:0;' +
                                                          'transition:opacity .25s ease, transform .25s ease;pointer-events:none;max-width:90vw;text-align:center;';
                                                              document.body.appendChild(toast);
                                                                  requestAnimationFrame(function () {
                                                                        toast.style.opacity = '1';
                                                                              toast.style.transform = 'translateX(-50%) translateY(0)';
                                                                                  });
                                                                                      setTimeout(function () {
                                                                                            toast.style.opacity = '0';
                                                                                                  setTimeout(function () { toast.remove(); }, 300);
                                                                                                      }, 2500);
                                                                                                        }

function showConfirmModal(message) {
  return new Promise(function (resolve) {
  var radius = 'var(--border-radius-theme, 8px)';
  var overlay = document.createElement('div');
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:100000;display:flex;align-items:center;justify-content:center;padding:20px;opacity:0;transition:opacity .15s ease;';
  var card = document.createElement('div');
  card.style.cssText = 'background:var(--background,#fff);color:var(--text-color,#111);border:1px solid var(--border-color,#e5e5e5);border-radius:' + radius + ';max-width:340px;width:100%;padding:26px 22px;box-shadow:0 12px 40px rgba(0,0,0,.3);font-family:inherit;text-align:center;transform:scale(.96);transition:transform .15s ease;';
  var text = document.createElement('p');
  text.textContent = message;
  text.style.cssText = 'margin:0 0 20px;font-size:16px;font-weight:600;color:var(--heading-color,inherit);line-height:1.4;';
  card.appendChild(text);
  var actions = document.createElement('div');
  actions.style.cssText = 'display:flex;gap:10px;';
  var cancelBtn = document.createElement('button');
  cancelBtn.type = 'button';
  cancelBtn.textContent = 'Cancelar';
  cancelBtn.style.cssText = 'flex:1;padding:12px;border-radius:' + radius + ';border:1px solid var(--border-color,#ccc);background:var(--secondary-button-background,#fff);color:var(--secondary-button-text-color,#111);font-weight:600;cursor:pointer;font-size:14px;font-family:inherit;';
  var confirmBtn = document.createElement('button');
  confirmBtn.type = 'button';
  confirmBtn.textContent = 'Confirmar';
  confirmBtn.style.cssText = 'flex:1;padding:12px;border-radius:' + radius + ';border:none;background:var(--primary-button-background,#111);color:var(--primary-button-text-color,#fff);font-weight:600;cursor:pointer;font-size:14px;font-family:inherit;';
  actions.appendChild(cancelBtn);
  actions.appendChild(confirmBtn);
  card.appendChild(actions);
  overlay.appendChild(card);
  document.body.appendChild(overlay);
  requestAnimationFrame(function () {
  overlay.style.opacity = '1';
  card.style.transform = 'scale(1)';
  });
  function close(result) {
  overlay.style.opacity = '0';
  setTimeout(function () { overlay.remove(); }, 150);
  resolve(result);
  }
  cancelBtn.addEventListener('click', function () { close(false); });
  confirmBtn.addEventListener('click', function () { close(true); });
  overlay.addEventListener('click', function (evt) { if (evt.target === overlay) close(false); });
  });
  }

  function performAddToCart(target, formElement) {
  target.setAttribute('disabled', 'disabled');
  fetch(''.concat(window.routes.cartAddUrl, '.js'), {
  body: new FormData(formElement),
  credentials: 'same-origin',
  method: 'POST',
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
  .then(function (res) { return res.json(); })
  .then(function (data) {
  target.removeAttribute('disabled');
  if (data.status) {
  showAddToCartToast(data.description || 'Nao foi possivel adicionar o produto.', true);
  return;
  }
  showAddToCartToast('Produto adicionado ao carrinho!');
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  bubbles: true,
  detail: { scrollToTop: false }
  }));
  document.documentElement.dispatchEvent(new CustomEvent('product:added', {
  bubbles: true,
  detail: { variant: data.variant, quantity: data.quantity }
  }));
  })
  .catch(function () {
  target.removeAttribute('disabled');
  showAddToCartToast('Nao foi possivel adicionar o produto. Tente novamente.', true);
  });
  }

  document.addEventListener('click', function (e) {
  var target = e.target.closest && e.target.closest('[data-action="add-to-cart-only"]');
  if (!target) return;

  var formElement = target.closest('form');
  if (!formElement) return;

  e.preventDefault();

  if (variantManuallySelected) {
  performAddToCart(target, formElement);
  return;
  }

  var checkedInput = formElement.querySelector('.product-form__single-selector:checked');
  var sizeLabel = checkedInput ? checkedInput.value : '';
  var confirmMsg = sizeLabel ? ('Confirma o tamanho ' + sizeLabel + '?') : 'Confirma a opcao selecionada?';
  showConfirmModal(confirmMsg).then(function (confirmed) {
  if (confirmed) performAddToCart(target, formElement);
  });
  });
  })();